import React from "react";
import { Link } from "react-router-dom";

const FloorList = ({
  floorsArray,
  setIsEditingName,
  setNewFloorName,
  setFloorId,
  restaurantId,
}) => {
  const handleEdit = (floor) => {
    setIsEditingName(true);
    setFloorId(floor._id);
    setNewFloorName(floor.floor_name);
  };

  console.log(restaurantId);

  return (
    <div>
      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th
                scope="col"
                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                ID
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Seating
              </th>

              <th
                scope="col"
                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {floorsArray.map((floor, index) => {
              return (
                <tr key={index}>
                  <td className="px-3 py-4  whitespace-nowrap text-xs">
                    {floor._id}
                  </td>

                  <td className="px-3 flex items-center py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer ">
                    {floor.floor_name}

                    <span
                      onClick={() => {
                        handleEdit(floor);
                      }}
                      className="ml-3"
                    >
                      <svg
                        className="edit-svg-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M16 2H8C4.691 2 2 4.691 2 8V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H16C19.309 22 22 19.309 22 16V8C22 4.691 19.309 2 16 2ZM8.999 17H7V15.001L12.53 9.479L14.529 11.478L8.999 17ZM15.472 10.535L13.473 8.536L14.997 7.013L16.996 9.012L15.472 10.535V10.535Z" />
                      </svg>
                    </span>
                  </td>

                  <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                    {floor.seating || "N/A"}
                  </td>

                  <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                    <Link
                      to={`/restaurantfloors/seating/${restaurantId}/${floor._id}/${floor.floor_name}`}
                      className="ml-3"
                    >
                      <button className="bg-gray-500 text-white px-2 py-2 rounded-md text-xs">
                        View Details
                      </button>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FloorList;
